/* eslint-disable react/prop-types */
import React from 'react';

const IconButton = props => {
    return (
        <button
            className={
                'icon-button' + (props.className ? ' ' + props.className : '') + ' cursor-hand'
            }
            onClick={props.onClick}
            title={props.title}
            disabled={props.disabled}
            data-description={props.dataDescription}
            data-element-id={props.dataElementId}
            tabIndex={props.tabIndex}
        >
            {props.icon && <img className="icon-image" src={props.icon} />}
            {props.labelText && <span className="label-text">{props.labelText}</span>}
        </button>
    );
};

export default IconButton;
